import { Injectable } from '@angular/core';

import { NativeAppService } from '@frontend/vanilla/core';

export interface SensitivePage {
    isSensitiveForPushNotifications: string;
    isSensitiveForSliderGames: string;
    action: string;
    id: string;
    type: string;
}

@Injectable({ providedIn: 'root' })
export class ModalEventBridgeService {
    private _eventName = 'SensitivePage';
    constructor(private nativeApp: NativeAppService) {}

    notifyOpenOverlay(): void {
        this.notifySensitivePage({
            isSensitiveForPushNotifications: 'false',
            isSensitiveForSliderGames: 'false',
            action: 'open',
            id: '',
            type: 'overlay',
        });
    }

    notifyCloseOverlay(): void {
        this.notifySensitivePage({
            isSensitiveForPushNotifications: 'false',
            isSensitiveForSliderGames: 'false',
            action: 'close',
            id: '',
            type: 'overlay',
        });
    }

    notifySensitivePage(page: SensitivePage): void {
        this.nativeApp.sendToNative({
            eventName: this._eventName,
            parameters: page,
        });
    }
}
